export class BackupZeroEtlSingleResourcePartitionConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "icebergPartitionSpec",
            "baseName": "icebergPartitionSpec",
            "type": "BackupZeroEtlIcebergPartitionSpec",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlSingleResourcePartitionConfig.attributeTypeMap;
    }
    constructor() {
    }
}
